import React, { useEffect, useRef } from "react";
import Home from "../home";
import { useState } from "react";
import Slider from "react-slick";
// import { BsArrowDown, BsArrowRight, BsArrowUp } from "react-icons/bs";
// import Loader from "../Loader";
import { Link } from "react-router-dom";
import Feedback from "../feedback";
import BackgroundMusicWithControl from "../audiofile";
import ReactPlayer from "react-player";
import HeroSectionBackground from "../../heroVideo/aquaMedMainVideo.mp4";

// const HeroSectionBackground = React.lazy(() => import('../../heroVideo/aquaMedMainVideo.mp4'))

function HereSection() {
  const baseUrl =
    process.env.NODE_ENV === "development"
      ? process.env.REACT_APP_BASE_URL_DEV
      : process.env.REACT_APP_BASE_URL_PROD;

  const baseUrl1 =
    process.env.NODE_ENV === "development"
      ? process.env.REACT_APP_BASE_URL_DEV1
      : process.env.REACT_APP_BASE_URL_PROD1;

  const [isAtTop, setIsAtTop] = useState(true);
  const sliderRef = useRef(null);

  // const backgroundImage = "url('/assets/hero.jpeg')";

  // const videoRef = useRef(null);
  // const [isMuted, setIsMuted] = useState(true);

  // const handleFullscreen = () => {
  //   const videoSrc = "./assets/video.mp4";
  //   const newTab = window.open("", "_blank");
  //   if (newTab) {
  //     newTab.document.write(`
  //       <video controls autoplay loop muted style="width: 100%; height: 100%;">
  //         <source src="${videoSrc}" type="video/mp4" />
  //         Your browser does not support the video tag.
  //       </video>
  //     `);
  //   }
  // };

  const NextArrow = ({ onClick }) => {
    return (
      <div
        className="arrow next absolute lg:h-[62%] xl:w-[393px]  h-[75%] w-[50px] lg:w-[250px] md:w-[200px] lg:right-[5%] md:right-[4%] right-[22%] md:top-[16%] top-[14%]"
        onClick={onClick}
      >
        {/* <FaArrowRight /> */}
      </div>
    );
  };

  const PrevArrow = ({ onClick }) => {
    return (
      <div
        className="arrow prev absolute lg:h-[62%] xl:w-[393px] h-[75%] w-[35px] lg:w-[250px] md:w-[200px] md:left-[12%] left-[30%] md:top-[16%] top-[14%]"
        onClick={onClick}
      >
        {/* <FaArrowLeft /> */}
      </div>
    );
  };

  const [imageIndex, setImageIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      if (sliderRef.current) {
        sliderRef.current.slickNext();
      }
    }, 5000);

    return () => clearInterval(interval);
  }, []);
  // Slider settings
  const settings = {
    infinite: true,
    lazyLoad: "ondemand",
    speed: 600,
    cssEase: "ease",
    slidesToShow: 3,
    centerMode: true,
    centerPadding: "0px",
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    beforeChange: (current, next) => setImageIndex(next),
    ref: sliderRef,
  };

  const [images, setImages] = useState([]);

  useEffect(() => {
    const fetchServices = async () => {
      try {
        const response = await fetch(`${baseUrl}/home/services`);
        if (response.status === 200) {
          const data = await response.json();
          // console.log('Fetched data:', data);
          setImages(data);
        } else {
          throw new Error("Unable to fetch data");
        }
      } catch (err) {
        console.error(err);
        setImages([]);
      }
    };

    fetchServices();
  }, []);

  const scrollToSlide = (index) => {
    if (sliderRef.current) {
      sliderRef.current.slickGoTo(index);
    }
  };

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.scrollY;
      if (scrollTop === 0) {
        setIsAtTop(true);
      } else {
        setIsAtTop(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const [isloading, setIsloading] = useState(true);

  useEffect(() => {
    const fakeDatafetch = () => {
      setTimeout(() => {
        setIsloading(false);
      }, 1000);
    };
    fakeDatafetch();
  }, []);

  const section1Ref = useRef(null);

  const scrollToSection = (ref) => {
    if (ref.current) {
      ref.current.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  // video mute
  const videoRef = useRef(null);
  const [isMuted, setIsMuted] = useState(true);

  const toggleMute = () => {
    if (videoRef.current) {
      videoRef.current.muted = !isMuted;
      setIsMuted(!isMuted);
    }
  };

  const [bouchers, setBouchers] = useState([]);

  useEffect(() => {
    const fetchBoucher = async () => {
      try {
        const response = await fetch(`${baseUrl}/home/brochures`);
        if (response.status === 200) {
          const data = await response.json();
          console.log("Fetched data gggg:", data);
          setBouchers(Array.isArray(data.data) ? data.data : []);
        } else {
          throw new Error("Unable to fetch data");
        }
      } catch (err) {
        console.error(err);
      }
    };

    fetchBoucher();
  }, []);

  // useEffect(() => {
  //     const fetchBouchers = async () => {
  //         try {
  //             const response = await fetch(`${baseUrl}/booking/getbouchers`);
  //             const result = await response.json();

  //             if (response.ok) {
  //                 setBouchers(result.bouchers);
  //                 console.log(result.bouchers);

  //             } else {
  //                 console.error(result.message);
  //             }
  //         } catch (error) {
  //             console.error("Error fetching brochures:", error);
  //         }
  //     };

  //     fetchBouchers();
  // }, []);

  // const [videoData, setVideoData] = useState(null);

  // useEffect(() => {
  //   const fetchVideo = async () => {
  //     try {
  //       const response = await fetch(`${baseUrl}/home/video`);
  //       const result = await response.json();
  //       if (result.isSuccess && result.data) {
  //         // setVideoData(result.data);
  //         console.log(result);
  //       } else {
  //         console.warn("No active video found");
  //       }
  //     } catch (error) {
  //       console.error("Error fetching video:", error);
  //     }
  //   };

  //   fetchVideo();
  // }, []);

  return (
    <>
      <div className="overflow-x-hidden">
        <div className="w-screen lg:h-screen overflow-hidden relative">
          <div className="w-full lg:h-full md:h-[400px] h-[260px]">
            <ReactPlayer
              src={HeroSectionBackground}
              url={HeroSectionBackground}
              playing
              loop
              muted={isMuted}
              playsinline
              ref={videoRef}
              rel="preload"
              lazyLoad
              width="100%"
              height="100%"
              className="object-fill"
            />
          </div>
          {/* <video
            className="w-full lg:h-full md:h-[400px] h-[260px] object-fill"
            autoPlay
            loop
            muted={isMuted}
            playsInline
            ref={videoRef}
            src={videoData ? `${baseUrl1}/${videoData.videoPath}` : ""}
          >
            Your browser does not support the video tag.
          </video> */}
          <button
            onClick={toggleMute}
            className="absolute bottom-6 right-10 bg-[#A3D284] text-white px-4 py-2 rounded-lg shadow-md hover:bg-gray-700"
          >
            {isMuted ? (
              <div className="">
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 18"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M23 6L17 12M17 6L23 12M11 2L6 6H2V12H6L11 16V2Z"
                    stroke="#F3F3F3"
                    stroke-width="2.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </div>
            ) : (
              <div className="">
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M19.07 4.92999C20.9447 6.80527 21.9979 9.34835 21.9979 12C21.9979 14.6516 20.9447 17.1947 19.07 19.07M15.54 8.45999C16.4774 9.39763 17.0039 10.6692 17.0039 11.995C17.0039 13.3208 16.4774 14.5924 15.54 15.53M11 4.99999L6 8.99999H2V15H6L11 19V4.99999Z"
                    stroke="#F3F3F3"
                    stroke-width="2.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </div>
            )}
          </button>
        </div>
        <div id="partner" className="bg-[#13304F] md:py-3">
          <div class="logos">
            <div class="logos-slide flex gap-5 lg:gap-10 w-[500%] md:w-[300%] lg:w-[120%]">
              {bouchers.map((item, idx) =>
                item.images?.map((img, imgIdx) => (
                  <img
                    key={`${idx}-${imgIdx}`}
                    src={`${baseUrl1}/${img.imagePath}`}
                    alt={item.title}
                    className="w-[130px] md:w-[160px] lg:w-[260px] object-contain"
                  />
                )),
              )}
            </div>
          </div>
        </div>

        <div
          id="services"
          className="overflow-x-hidden  md:h-[100vh] h-[60vh] flex items-center justify-center"
        >
          <div className="w-full h-full relative">
            <p
              className="text-[#234971] lg:text-[28px] md:text-[22px] text-[18px] py-4 mt-6 font-[600] flex justify-center relative z-10"
              data-aos="fade-down"
              data-aos-duration="2000"
            >
              OUR SERVICES
            </p>
            <div className="App absolute w-[215%]  md:w-[120%] top-[20%] xl:top-[10%] md:top-[20%] -left-[65%] md:-left-[15%]">
              <Slider {...settings}>
                {images.map((item, idx) => (
                  <div
                    key={idx}
                    className={`${
                      idx === imageIndex ? "slide activeSlide" : "slide"
                    }`}
                  >
                    <div className="relative xl:h-[380px]  md:h-[270px] lg:h-[380px] h-[250px] w-full xl:mt-14 my-4 hover:h-">
                      <img
                        src="/assets/card.png"
                        alt={item.head}
                        className="img xl:h-[380px] md:h-[270px] h-[240px] w-full"
                      />
                      <div className="absolute lg:top-5 top-3 h-full w-full">
                        <div className="flex justify-center">
                          <img
                            src={item.thumbnails}
                            alt=""
                            className="xl:h-[160px] h-[100px]  w-[100px] xl:w-[160px] md:h-[90px] md:w-[90px] rounded-full object-cover"
                          />
                        </div>
                        <div className="flex justify-center items-center">
                          <p className="text-[#FFFFFF]  lg:text-[20px] md:text-[14px] w-[180px] md:w-[200px] lg:w-full mt-3 md:mt-5 text-[12px] lg:p-2 p-1 font-bold ">
                            {item.title}
                          </p>
                          {/* <p className="text-[#FFFFFF] text-[10px] lg:text-[16px] lg:leading-[28px] xl:px-10 px-2 xl:py-3 py-1 md:text-justify overflow-hidden text-ellipsis whitespace-pre-wrap h-[calc(3*40px)]">
                            {item.description}
                          </p> */}
                        </div>
                        <div className="flex justify-center lg:bottom-10 xl:bottom-20  bottom-10 absolute w-full">
                          <Link
                            to={`/ourservice/${encodeURIComponent(item.title)}?id=${item.categoryId}`}
                          >
                            <button className="flex items-center text-[12px] md:text-[14px] justify-evenly md:w-[115px]  md:h-[40px] h-[35px] w-[100px] bg-white text-[#234971] hover:bg-[#234971] hover:text-white transition-all duration-300 rounded-[40px] font-[600]">
                              More info
                              <img
                                src="./assets/hero/more.png"
                                alt="More Info"
                                className="bg-[#234971] h-[20px] md:h-[30px] lg:h-[30px] rounded-full md:p-2 p-1"
                              />
                            </button>
                            {/* vvv */}
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </Slider>
            </div>
          </div>
        </div>
        <Home section1Ref={section1Ref} />
      </div>

      <BackgroundMusicWithControl />

      <Feedback />
    </>
  );
}

export default HereSection;

{
  /* <div className="absolute md:bottom-[30px] bottom-2 left-3 bg-fixed z-20  feed">
        <div className="bg-[#A3D284] md:p-3 p-2 rounded-full bg-fixed cursor-pointer flex">
          <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M3 7.75C3 7.45453 3.0582 7.16194 3.17127 6.88896C3.28434 6.61598 3.45008 6.36794 3.65901 6.15901C3.86794 5.95008 4.11598 5.78434 4.38896 5.67127C4.66194 5.5582 4.95453 5.5 5.25 5.5C5.54547 5.5 5.83806 5.5582 6.11104 5.67127C6.38402 5.78434 6.63206 5.95008 6.84099 6.15901C7.04992 6.36794 7.21566 6.61598 7.32873 6.88896C7.4418 7.16194 7.5 7.45453 7.5 7.75C7.5 8.34674 7.26295 8.91903 6.84099 9.34099C6.41903 9.76295 5.84674 10 5.25 10C4.65326 10 4.08097 9.76295 3.65901 9.34099C3.23705 8.91903 3 8.34674 3 7.75ZM5.25 7C5.05109 7 4.86032 7.07902 4.71967 7.21967C4.57902 7.36032 4.5 7.55109 4.5 7.75C4.5 7.94891 4.57902 8.13968 4.71967 8.28033C4.86032 8.42098 5.05109 8.5 5.25 8.5C5.44891 8.5 5.63968 8.42098 5.78033 8.28033C5.92098 8.13968 6 7.94891 6 7.75C6 7.55109 5.92098 7.36032 5.78033 7.21967C5.63968 7.07902 5.44891 7 5.25 7ZM5.25 11C4.65326 11 4.08097 11.2371 3.65901 11.659C3.23705 12.081 3 12.6533 3 13.25C3 13.8467 3.23705 14.419 3.65901 14.841C4.08097 15.2629 4.65326 15.5 5.25 15.5C5.84674 15.5 6.41903 15.2629 6.84099 14.841C7.26295 14.419 7.5 13.8467 7.5 13.25C7.5 12.6533 7.26295 12.081 6.84099 11.659C6.41903 11.2371 5.84674 11 5.25 11ZM4.5 13.25C4.5 13.0511 4.57902 12.8603 4.71967 12.7197C4.86032 12.579 5.05109 12.5 5.25 12.5C5.44891 12.5 5.63968 12.579 5.78033 12.7197C5.92098 12.8603 6 13.0511 6 13.25C6 13.4489 5.92098 13.6397 5.78033 13.7803C5.63968 13.921 5.44891 14 5.25 14C5.05109 14 4.86032 13.921 4.71967 13.7803C4.57902 13.6397 4.5 13.4489 4.5 13.25ZM9 7.75C9 7.55109 9.07902 7.36032 9.21967 7.21967C9.36032 7.07902 9.55109 7 9.75 7H14.25C14.4489 7 14.6397 7.07902 14.7803 7.21967C14.921 7.36032 15 7.55109 15 7.75C15 7.94891 14.921 8.13968 14.7803 8.28033C14.6397 8.42098 14.4489 8.5 14.25 8.5H9.75C9.55109 8.5 9.36032 8.42098 9.21967 8.28033C9.07902 8.13968 9 7.94891 9 7.75ZM9.75 12.5C9.55109 12.5 9.36032 12.579 9.21967 12.7197C9.07902 12.8603 9 13.0511 9 13.25C9 13.4489 9.07902 13.6397 9.21967 13.7803C9.36032 13.921 9.55109 14 9.75 14H14.25C14.4489 14 14.6397 13.921 14.7803 13.7803C14.921 13.6397 15 13.4489 15 13.25C15 13.0511 14.921 12.8603 14.7803 12.7197C14.6397 12.579 14.4489 12.5 14.25 12.5H9.75ZM3 3.75C3 3.55109 3.07902 3.36032 3.21967 3.21967C3.36032 3.07902 3.55109 3 3.75 3H14.25C14.4489 3 14.6397 3.07902 14.7803 3.21967C14.921 3.36032 15 3.55109 15 3.75C15 3.94891 14.921 4.13968 14.7803 4.28033C14.6397 4.42098 14.4489 4.5 14.25 4.5H3.75C3.55109 4.5 3.36032 4.42098 3.21967 4.28033C3.07902 4.13968 3 3.94891 3 3.75ZM3.25 0C2.38805 0 1.5614 0.34241 0.951903 0.951903C0.34241 1.5614 0 2.38805 0 3.25V14.75C0 15.612 0.34241 16.4386 0.951903 17.0481C1.5614 17.6576 2.38805 18 3.25 18H14.75C15.612 18 16.4386 17.6576 17.0481 17.0481C17.6576 16.4386 18 15.612 18 14.75V3.25C18 2.38805 17.6576 1.5614 17.0481 0.951903C16.4386 0.34241 15.612 0 14.75 0H3.25ZM1.5 3.25C1.5 2.284 2.284 1.5 3.25 1.5H14.75C15.716 1.5 16.5 2.284 16.5 3.25V14.75C16.5 15.2141 16.3156 15.6592 15.9874 15.9874C15.6592 16.3156 15.2141 16.5 14.75 16.5H3.25C2.78587 16.5 2.34075 16.3156 2.01256 15.9874C1.68437 15.6592 1.5 15.2141 1.5 14.75V3.25Z" fill="#202020" />
          </svg>
          <p className="pl-2 md:text-[16px] text-[10px]">

            <a href="https://www.bloodsandbeyond.co.uk/" target="_blank" rel="noopener noreferrer" className="text-[#303030]">
              Mobile Phlebotomy Appointment
            </a>
          </p>
        </div>
      </div> */
}
{
  /* <a href="" target="_blank" rel="noopener noreferrer" className="text-[#303030]">
        <div className="bg-[#A3D284] md:p-3 p-2 fixed left-4 bottom-4 rounded-full bg-fixed cursor-pointer flex "> */
}

{
  /* <BsArrowUp size={24} /> */
}

{
  /* <span className="pr-2 md:text-[16px] text-[10px] px-2">  </span>
        </div>
      </a> */
}

{
  /* OLD DESIGN  */
}
{
  /* <div
          className=" overflow-x-hidden h-screen flex items-center justify-center] "
          style={{
            backgroundImage: "url(/assets/hero1.png)",
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        >
          <div className="lg:flex justify-between items-center bg-black h-full bg-opacity-[40%] lg:px-[calc((100%-1280px)/2)] px-5 gap-10 pt-20 w-full">
            <div
              className="lg:w-[50%] Figtree text-[#ffffff] w-full text-center lg:text-start lg:mb-0 mb-2"
              data-aos="fade-right"
              data-aos-duration="1500"
            >
              <div className="flex justify-center lg:justify-start">
                <img
                  src="./assets/animate_logo.png"
                  className="h-[160px] w-[160px] animate-logoRotateY xl:ml-20"
                  alt=""
                />
              </div>
              <p className="md:text-[26px]  text-[16px] lg:py-4 font-[600]">
                Navigating Well-Being With Bespoke Precision
              </p>
              <p className="md:text-[20px] text-[14px] font-[400] lg:pb-4 py-2">
                {" "}
                Testing the Wellness of Tomorrow
              </p>
              <div className="flex justify-center lg:justify-start">
                <button
                  onClick={() => scrollToSection(section1Ref)}
                  className="md:w-[160px] w-[130px] md:h-[44px] h-[30px] flex justify-center items-center gap-4 md:text-[14px] text-[12px] text-white bg-[#234971] hover:text-[#234971] hover:bg-white transition-all duration-500 hover:border hover:border-[#234971] font-[500] rounded-[50px]"
                >
                  <p className="">Book Appointment</p>
                </button>
              </div>
            </div>
            <div
              className="flex justify-center lg:justify-start"
              data-aos="fade-left"
              data-aos-duration="1500"
            >
              <div className="relative">
                <video
                  className="relative h-[200px] lg:h-[300px] xl:h-full w-full"
                  autoPlay
                  loop
                  muted={isMuted}
                  playsInline
                  ref={videoRef}
                  src="./assets/video.mp4"
                />
                <div className="absolute right-3 bottom-3 flex gap-3">
                  <button
                    onClick={handleFullscreen}
                    className="p-1 bg-blue-500 text-white rounded"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-6 w-6"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth={2}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M8 3H3v5M3 3l6 6M16 3h5v5M21 3l-6 6M8 21H3v-5M3 21l6-6M16 21h5v-5M21 21l-6-6" />
                    </svg>
                  </button>
                  <button
                    onClick={toggleMute}
                    className="p-1 bg-blue-500 text-white rounded"
                  >
                    {isMuted ? (
                      <div className="">
                        <svg
                          width="24"
                          height="24"
                          viewBox="0 0 24 18"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M23 6L17 12M17 6L23 12M11 2L6 6H2V12H6L11 16V2Z"
                            stroke="#F3F3F3"
                            stroke-width="2.5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                      </div>
                    ) : (
                      <div className="">
                        <svg
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M19.07 4.92999C20.9447 6.80527 21.9979 9.34835 21.9979 12C21.9979 14.6516 20.9447 17.1947 19.07 19.07M15.54 8.45999C16.4774 9.39763 17.0039 10.6692 17.0039 11.995C17.0039 13.3208 16.4774 14.5924 15.54 15.53M11 4.99999L6 8.99999H2V15H6L11 19V4.99999Z"
                            stroke="#F3F3F3"
                            stroke-width="2.5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                      </div>
                    )}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div> */
}

{
  /* NEW DESIGN  */
}
{
  /* <div className=" overflow-x-hidden min-h-screen h-auto pt-10 bg-[#000]"> */
}
{
  /* <div className=" md:flex bg-[#ffffff] bg-opacity-[40%] lg:ml-2 xl:ml-0 lg:px-[calc((100%-1280px)/2)] px-5 gap-10 pt-20 lg:mt-[90px] xl:mt-[30px] w-full">
            <div
              className="lg:w-[50%] Figtree text-[#234971] w-full text-center lg:text-start lg:mb-0 mb-2"
              data-aos="fade-right"
              data-aos-duration="1500"
            >
              <div className="flex justify-center lg:justify-start">
                <img
                  src="./assets/animate_logo.png"
                  className="h-[100px] w-[80px] lg:h-[120px] lg:w-[120px] animate-logoRotateY xl:ml-20"
                  alt=""
                />
              </div>
              <p className="lg:text-[26px]  text-[16px] lg:pt-4 font-[600]">
                Navigating Well-Being With Bespoke Precision
              </p>
              <p className="md:text-[20px] text-[14px] font-[400] lg:pt-2 lg:pb-4 ">
                {" "}
                Testing the Wellness of Tomorrow
              </p>
              <div className="flex justify-center lg:justify-start">
                <button
                  onClick={() => scrollToSection(section1Ref)}
                  className="md:w-[160px] w-[130px] md:h-[44px] h-[30px] flex justify-center items-center gap-4 md:text-[14px] text-[12px] text-white bg-[#234971] hover:text-[#234971] hover:bg-white transition-all duration-500 hover:border hover:border-[#234971] font-[500] rounded-[50px]"
                >
                  <p className="">Book Appointment</p>
                </button>
              </div>
            </div>

            <div
              className="flex justify-center lg:justify-start"
              data-aos="fade-left"
              data-aos-duration="1500"
            >
              <div className="relative">
                <video
                  className="relative h-[200px] md:h-[200px] lg:h-[260px] xl:h-[270px] w-full border-[10px] border-[#A3D284]"
                  autoPlay
                  loop
                  muted={isMuted}
                  playsInline
                  ref={videoRef}
                  src="./assets/video.mp4"
                />
                <div className="absolute right-3 bottom-3 lg:bottom-16 xl:bottom-7 flex gap-3">
                  <button
                    onClick={handleFullscreen}
                    className="p-1 bg-blue-500 text-white rounded"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-6 w-6"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth={2}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M8 3H3v5M3 3l6 6M16 3h5v5M21 3l-6 6M8 21H3v-5M3 21l6-6M16 21h5v-5M21 21l-6-6" />
                    </svg>
                  </button>
                  <button
                    onClick={toggleMute}
                    className="p-1 bg-blue-500 text-white rounded"
                  >
                    {isMuted ? (
                      <div className="">
                        <svg
                          width="24"
                          height="24"
                          viewBox="0 0 24 18"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M23 6L17 12M17 6L23 12M11 2L6 6H2V12H6L11 16V2Z"
                            stroke="#F3F3F3"
                            stroke-width="2.5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                      </div>
                    ) : (
                      <div className="">
                        <svg
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M19.07 4.92999C20.9447 6.80527 21.9979 9.34835 21.9979 12C21.9979 14.6516 20.9447 17.1947 19.07 19.07M15.54 8.45999C16.4774 9.39763 17.0039 10.6692 17.0039 11.995C17.0039 13.3208 16.4774 14.5924 15.54 15.53M11 4.99999L6 8.99999H2V15H6L11 19V4.99999Z"
                            stroke="#F3F3F3"
                            stroke-width="2.5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                      </div>
                    )}
                  </button>
                </div>
              </div>
            </div>
          </div> */
}

{
  /* <div className="lg:flex lg:ml-2 xl:ml-0 lg:px-[calc((100%-1280px)/2)] px-5 gap-10 mt-3 md:mt-10 lg:mt-20 xl:mt-10 w-full">
            <div className="relative border-[10px] border-[#A3D284] h-[250px] md:h-[270px] lg:h-[300px] md:w-[680px] shadow-md rounded-md overflow-hidden">
              <img
                src="./assets/cover 2.png"
                className="absolute top-0 left-0 h-full w-full"
                alt="Laboratory Background"
              />

              <div className="absolute inset-0 flex flex-col items-center justify-between text-center p-5">
                <div className="flex flex-row gap-3 items-center mb-5">
                  <img
                    src="./assets/animate_logo.png"
                    alt="Logo"
                    className="h-[50px] w-[50px]"
                  />
                  <p className="text-white font-semibold text-[10px] md:text-[13px]">
                    Aqua Medical Laboratories at the 2025 Integrative &
                    Personalised Medicine
                  </p>
                </div>

                <div className="grid grid-cols-4 gap-5 text-white">
                  <div className="flex flex-col items-center">
                    <svg
                    className="!text-[10px]"
                      width="48"
                      height="48"
                      viewBox="0 0 48 48"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M36 16C36 23.226 28.262 30.858 25.214 33.59C24.8653 33.8563 24.4387 34.0006 24 34.0006C23.5613 34.0006 23.1347 33.8563 22.786 33.59C19.74 30.858 12 23.226 12 16C12 12.8174 13.2643 9.76516 15.5147 7.51472C17.7652 5.26428 20.8174 4 24 4C27.1826 4 30.2348 5.26428 32.4853 7.51472C34.7357 9.76516 36 12.8174 36 16Z"
                        stroke="white"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M24 20C26.2091 20 28 18.2091 28 16C28 13.7909 26.2091 12 24 12C21.7909 12 20 13.7909 20 16C20 18.2091 21.7909 20 24 20Z"
                        stroke="white"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M17.4281 28H10.0081C9.58878 28.0002 9.18011 28.1322 8.83987 28.3773C8.49964 28.6224 8.24506 28.9683 8.11213 29.366L4.10413 41.366C4.00365 41.6666 3.97606 41.9868 4.02364 42.3002C4.07121 42.6136 4.19259 42.9112 4.37777 43.1684C4.56294 43.4257 4.80661 43.6352 5.08868 43.7798C5.37076 43.9244 5.68316 43.9999 6.00013 44H42.0001C42.3169 43.9998 42.629 43.9243 42.9109 43.7798C43.1927 43.6353 43.4363 43.426 43.6214 43.169C43.8065 42.912 43.928 42.6147 43.9757 42.3016C44.0235 41.9885 43.9962 41.6685 43.8961 41.368L39.8961 29.368C39.7634 28.9696 39.5087 28.6231 39.168 28.3775C38.8274 28.132 38.4181 27.9999 37.9981 28H30.5741"
                        stroke="white"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>

                    <p className="text-[10px] md:text-[14px] font-semibold mt-2">STAND F60</p>
                  </div>

                  <div className="flex flex-col items-center">
                    <svg
                      width="49"
                      height="48"
                      viewBox="0 0 49 48"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M42.5 15V12C42.5 10.9391 42.0786 9.92172 41.3284 9.17157C40.5783 8.42143 39.5609 8 38.5 8H10.5C9.43913 8 8.42172 8.42143 7.67157 9.17157C6.92143 9.92172 6.5 10.9391 6.5 12V40C6.5 41.0609 6.92143 42.0783 7.67157 42.8284C8.42172 43.5786 9.43913 44 10.5 44H17.5"
                        stroke="white"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M32.5 4V12"
                        stroke="white"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M16.5 4V12"
                        stroke="white"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M6.5 20H16.5"
                        stroke="white"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M35.5 35L32.5 32.6V28"
                        stroke="white"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M32.5 44C39.1274 44 44.5 38.6274 44.5 32C44.5 25.3726 39.1274 20 32.5 20C25.8726 20 20.5 25.3726 20.5 32C20.5 38.6274 25.8726 44 32.5 44Z"
                        stroke="white"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>

                    <p className="text-[10px] md:text-[14px] font-semibold mt-2">19 - 25</p>
                    <p className="text-[10px] md:text-[14px] font-semibold ">JUNE 2025</p>
                  </div>

                  <div className="flex flex-col items-center">
                    <svg
                      width="48"
                      height="48"
                      viewBox="0 0 48 48"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M24 44C35.0457 44 44 35.0457 44 24C44 12.9543 35.0457 4 24 4C12.9543 4 4 12.9543 4 24C4 35.0457 12.9543 44 24 44Z"
                        stroke="white"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M24 4C18.8645 9.39231 16 16.5535 16 24C16 31.4465 18.8645 38.6077 24 44C29.1355 38.6077 32 31.4465 32 24C32 16.5535 29.1355 9.39231 24 4Z"
                        stroke="white"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M4 24H44"
                        stroke="white"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>

                    <p className="text-[10px] md:text-[14px] font-semibold mt-2">LONDON, UK</p>
                  </div>
                  
                  <img
                  src="./assets/Integrative.png"
                  alt="Logo"
                  className="h-[90px] w-[110px]"
                />
                </div>

            
                <div className="mt-5 flex !justify-start">
                  <p className="text-white text-sm font-medium">
                    www.aquamedlabs.com
                  </p>
                </div>
              </div>
            </div>
          </div> */
}
